import React from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { PERIOD_LABELS } from "@components/settings/OrganizationCloseTemplates/serviceTemplateSchedule.constants";
import { formatFilterLabelText } from "./formatFilterLabel";

interface Props {
    filters: Pick<FiltersTypes, "schedulePeriods">;
}

export const SchedulePeriodFilterLabel: React.FC<Props> = ({ filters }) => {
    const text = formatFilterLabelText(
        (filters.schedulePeriods ?? []).map((p) => PERIOD_LABELS[p]),
        "Periods",
    );
    return <>{text ?? "All"}</>;
};
